import { ACTION_TYPES, Club } from '../../types';

export const fetchClubsPending = () => ({
  type: ACTION_TYPES.FETCH_CLUBS_PENDING,
});

export const fetchClubsSuccess = (clubs: Club[]) => ({
  type: ACTION_TYPES.FETCH_CLUBS_FETCHED,
  payload: clubs,
});

export const fetchClubsError = (error: string) => ({
  type: ACTION_TYPES.FETCH_CLUBS_ERROR,
  payload: error,
});
